import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancelPage() {
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle size={80} weight="duotone" className="text-neutral-500 mx-auto mb-6" />
      <h1 className="font-display font-black text-5xl tracking-tighter mb-4">Payment Cancelled</h1>
      <p className="text-neutral-600 mb-8">No charge has been made. Your cart items are still saved.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/checkout" className="vt-btn-orange">Try Again</Link>
        <Link to="/cart" className="vt-btn-outline">Back to Cart</Link>
      </div>
    </div>
  );
}
